exports.onRouteUpdate = ({ location, prevLocation }) => {
    if (prevLocation === null) {
        // first load
        window.norlash_pageview_registered = true;
    } else {
        window.norlash_pageview_registered = false;
    }
};